import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { trpc } from '../config/trpc';
import { useTargetAccount } from '../hooks/useTargetAccount';

export const AccountSwitchPrompt = ({ accountId }: { accountId: number }) => {
  const initialRef = useRef(null);
  const { targetAccount: currentAccount, changeTargetAccount } = useTargetAccount();
  const navigate = useNavigate();

  const { data, isFetched, isError } = trpc.getAccount.useQuery(
    { id: accountId },
    { retry: false, enabled: !!accountId },
  );

  const onSwitch = useCallback(() => {
    changeTargetAccount({
      business_type: data?.business_type,
      iata_number: data?.iata_number,
      id: data?.id,
      is_iata_number_verified: data?.is_iata_number_verified,
      name: data?.name,
      is_fulfillment_partner: !!data?.fulfillment_partner_configurations?.length,
      type: data?.type,
    });
    window.location.reload();
  }, [data, changeTargetAccount]);

  if (currentAccount?.id === accountId || (!data && (isFetched || isError))) return null;

  return (
    <Modal onClose={() => {}} isOpen={!!accountId && isFetched} initialFocusRef={initialRef}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Would you like to switch accounts?</ModalHeader>
        <ModalBody>
          <Stack spacing={4}>
            <Text>You're trying to access a page that's unavailable for your currently selected account.</Text>
            <Text>
              Would you like to switch to
              <Text fontWeight="bold" display="inline">{` ${data?.name} `}</Text>
              and view this page?
            </Text>
          </Stack>
        </ModalBody>
        <ModalFooter gap={2}>
          <Button onClick={() => navigate('/')}>Cancel</Button>
          <Button ref={initialRef} colorScheme="primary" onClick={onSwitch}>
            Switch Account
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
